<template>
    <div class="ResidenceRecord">
        <div class="container-fluid">
            <div class="row">
                <div class="col col-md-12">
                    <button type="button" class="close" v-on:click="CloseRecord"><span>x</span></button>
                    <h1><span>{{ ResidenceData.Name }}</span></h1>
                    <h3><span>{{ ResidenceData.SubProgram.Name }} </span></h3>
                </div>
            </div>
            <div class="row" style="margin-top: 10px;">
                <div class="col">
                    <div class="record-tabs">
                        <span class="d-none d-sm-block">
                            <b-nav>
                                <div v-for="pane in Panes">
                                    <div v-if="pane.name == 'Medication' && CheckPermission('Residential_Medication')">
                                        <b-nav-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-nav-item>
                                    </div>
                                    <div v-else-if="pane.name != 'Medication'">
                                        <b-nav-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-nav-item>
                                    </div>
                                </div>
                            </b-nav>
                        </span>
                        <b-nav>
                            <span class="d-sm-none">
                                <b-nav-item-dropdown :text=changeDropdownName id="mobileDropdown">
                                    <div v-for="pane in Panes">
                                        <div v-if="pane.name == 'Medication' && CheckPermission('Residential_Medication')">
                                            <b-dropdown-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-dropdown-item>
                                        </div>
                                        <div v-else-if="pane.name != 'Medication'">
                                            <b-dropdown-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-dropdown-item>
                                        </div>
                                    </div>
                                </b-nav-item-dropdown>
                            </span>
                        </b-nav>
                    </div>
                    <div class="tab-content">
                        <div v-show="PaneShown == 'Summary'">
                            <ResidenceSummary v-bind:residence-data="ResidenceData" />
                        </div>
                        <div v-show="PaneShown == 'House Grades'">
                            <HouseGrades v-bind:residence-data="ResidenceData" />
                        </div>
                        <div v-if="PaneShown == 'Medication' && CheckPermission('Medication.DispensationPlan.Read')">
                            <ResidenceMedicationManagement v-bind:residence-id="ResidenceData.Id" />
                        </div>

                        <div v-if="CheckPermission('ResidentialMeals_Module')" v-show="PaneShown == 'Meals'">
                            <ResidentialMeals v-bind:residence-data="ResidenceData" />
                        </div>
                        <div if="PaneShown == 'Reports'">
                            <Reports v-bind:residence-data="ResidenceData" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    //import CaseFile from "../../../Core/RecordComponents/CaseFile.vue";
    import Information from "./Information.vue";
    //import NewDocument from "../../../Core/RecordComponents/NewDocument.vue";
    import People from "./People.vue";
    import ResidenceSummary from "./Summary.vue";
    import HouseGrades from "./HouseGrades.vue";
    import ResidentialMeals from "./ResidentialMeals.vue";
    import ResidenceMedicationManagement from "../../../Core/MedicationManagement/ResidenceMedicationManagement.vue";
    import Reports from "./Reports.vue";
    export default {
        mounted: function() {
            if (this.DisplayBxGrades) {
                this.Panes.push({name: 'House Grades'});
            }
            if (this.CheckPermission("ResidentialMeals_Module")) {
                this.Panes.push({ name: 'Meals' });
            }
            if (this.CheckPermission("Medication.DispensationPlan.Read")) {
                this.Panes.push({ name: 'Medication' });
            }
        },
        props: [
            'ResidenceData'
        ],
        data: function () {
            return {
                PaneShown: "Summary",
                Panes: [
                    { name: 'Summary' },
                    { name: 'Reports' },
                    //{ name: 'Information' },
                    //{ name: 'People' },
                ],
                DocumentView: "NewDocument",
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                this.PaneShown = paneName;
            },
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CloseRecord() {
                this.$parent.CloseRecord("Residences.ResidenceProfiles.Remove","ResidenceList",this.ResidenceData.Id);
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            ResidenceSummary,
            //CaseFile,
            Information,
            //NewDocument,
            People,
            HouseGrades,
            ResidentialMeals,
            ResidenceMedicationManagement,
            Reports,
        },
        computed: {
            changeDropdownName: function () {
                return this.PaneShown;
            },
            SubProgramFormMemberships: function () {
                let subProgram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.ResidenceData.SubProgramID);
                return subProgram.FormMemberships.filter(fm => fm.ChartType == "Residence");
            },
            DisplayBxGrades: function () {
                let subProgram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.ResidenceData.SubProgramID);
                if (subProgram.Name == "Inland STRTP" || subProgram.Name == "Hope Refuge") {
                    return true;
                } else {
                    return false;
                }
            }
        },
    }
</script>

<style scoped>
    .record-tabs {
        width: 100%;
        display: inline-block;
    }
</style>